import React, { Component } from 'react';
import Button from '../../Button/Button';
import './Success.css';

class Success extends Component {
	render(){
		return(
			<div className="container success-page">
			<img src={this.props.successImg} alt="Success"/>
			<p className="success-header">Sign Up Successful</p>
			<p className="success-text">Your FMeasure plan is ready for use. Please click ‘Continue’ below to head over to the console.</p>
			<Button label="Continue" onClick={() => this.props.changeLocation('/dashboard/search')}/>
			</div>
			)
	}
}

export default Success;


// WEBPACK FOOTER //
// ./src/components/SignUp/Success/Success.js